import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import SaveIcon from "../../../assets/svg/saveIcon.svg";
import API from "../../../helpers/endpointService";
import axios from "axios";
import ExpiryPeriodIcon from "../../../assets/svg/expiryperiodmaxIcon.svg";
import { makeStyles } from "@material-ui/core/styles";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { PulseLoader } from "react-spinners";
import { logoutFunction } from "../../custom/commonFunction";

const useStyles = makeStyles((theme) => ({
  inputfieldAlign: {
    "& fieldset": {
      top: "-1px !important",
    },
  },
  button: {
    background: "#FFFFFF",
    border: "none",
    boxSizing: "border-box",
    paddingLeft: "11px",
    paddingRight: "20px",
  },
}));

const ExpiryPeriod = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [isMobile, setisMobile] = useState(false);
  const [isRadioMobile, setisRadioMobile] = useState(false);
  const [isSmallMobile, setisSmallMobile] = useState(false);
  const [isExpiryLoader, setExpiryLoader] = useState(true);
  const [isExpiryFailed, setExpiryFailed] = useState(false);
  const [isEdit, setisEdit] = useState(false);
  const [expiryperiodList, setexpiryperiodList] = useState({
    NotificationValue: 0,
  });
  const [windowHeight, setwindowHeight] = useState(0);

  useEffect(() => {
    setExpiryLoader(true);
    setExpiryFailed(false);
    GetNotificationPeriodValue();
    const intervals = setInterval(() => {
      resize();
    }, 10);
    return () => clearInterval(intervals);
  }, []);

  const resize = () => {
    setwindowHeight(window.innerHeight);
    if (window.innerWidth < 850) {
      setisMobile(true);
    } else {
      setisMobile(false);
    }
    if (window.innerWidth < 450) {
      setisRadioMobile(true);
    } else {
      setisRadioMobile(false);
    }
    if (window.innerWidth < 300) {
      setisSmallMobile(true);
    } else {
      setisSmallMobile(false);
    }
  };

  const GetNotificationPeriodValue = () => {
    let apiUrl = `${API.GET_NOTIFICATION_PERIOD}`;
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((res) => {
        if (res.status === 200) {
          setExpiryLoader(false);
          setexpiryperiodList({
            NotificationValue: res.data,
          });
        }
      })
      .catch((error) => {
        setExpiryLoader(false);
        setExpiryFailed(false);

        logoutFunction(error?.response?.status);
      });
  };

  const handleNotificationInputChange = (e) => {
    dispatch({ type: "CANCEL", data: true });
    var pattern = /^(0|[1-9][0-9]*)$/;
    if (e.target.value !== "") {
      if (pattern.test(e.target.value)) {
        const phone = e.target.validity.valid
          ? e.target.value
          : expiryperiodList.NotificationValue;
        setexpiryperiodList({ NotificationValue: phone });
      } else {
        toast.error("This format is not allowed.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    } else {
      setexpiryperiodList({
        NotificationValue: e.target.value,
      });
    }
  };

  const SaveNotificationPeriod = () => {
    if (expiryperiodList.NotificationValue !== "") {
      let Notifiyvalue = parseInt(expiryperiodList.NotificationValue);
      if (Notifiyvalue === 0) {
        toast.error(
          "Expiry period should be greater than 0.Please enter another value.",
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          }
        );
      } else {
        setExpiryLoader(true);
        setExpiryFailed(false);
        dispatch({ type: "CANCEL", data: false });
        let apiUrl = `${API.PUT_NOTIFICATION_PERIOD}?expiryPeriod=${expiryperiodList.NotificationValue}`;
        axios({
          method: "PUT",
          url: apiUrl,
        })
          .then((res) => {
            if (res.status === 200) {
              if (res.data === "Expiry period is same") {
                setExpiryLoader(false);
                setExpiryFailed(false);
                toast.error(
                  "This value is already saved. please enter another value.",
                  {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                  }
                );
              } else {
                GetNotificationPeriodValue();
                toast.success("Saved successfully", {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "colored",
                });
              }
            }
          })
          .catch((error) => {
            setExpiryLoader(false);
            setExpiryFailed(false);

            logoutFunction(error?.response?.status);
          });
      }
    } else {
      toast.error("Atleast one value is mandatory.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };
  return (
    <>
      <div className={`${isMobile ? "main-body-mobile" : "main-body"}`}>
        {isExpiryLoader && (
          <div className="spinner_overlay">
            <div className="loader">
              <PulseLoader color="#D12232" size={10} speedMultiplier={1} />
            </div>
          </div>
        )}

        {isExpiryFailed && (
          <div className="spinner_overlay">
            <div className="loader">
              <span>Loading failed</span>
            </div>
          </div>
        )}
        {isMobile == true ? (
          <div className="mobile-head border-bottom w-100">
            <div className="col-12 mobile-title">Notification period</div>
          </div>
        ) : (
          <div className="title">
            <img src={ExpiryPeriodIcon} />
            <span className="pl-10 head-span mt-10">Notification period</span>
          </div>
        )}
        <div
          className={`${isMobile ? "common-mobilesubmenu" : "common-submenu"}`}
        >
          <div
            className={`col-12 d-flex justify-content-start ${
              isMobile ? "pl-1 pr-0" : "pl-10"
            }`}
          >
            <button
              className={`displaybutton ${isRadioMobile ? "pr-5" : ""}  ${
                isSmallMobile ? "pl-5" : ""
              }`}
              id="displaybuttoncolor"
              onClick={SaveNotificationPeriod}
            >
              <img src={SaveIcon} />
              <span className={`subhead-span p-2`}>Save</span>
            </button>
            <ToastContainer limit={1} />
          </div>
        </div>
        <div
          className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 mb-2 p-3`}
        >
          <div className="form-group">
            <label
              className={`label-text ${
                isMobile ? "d-flex pt-2 mb-6" : "d-flex mb-6"
              }`}
            >
              <span className="pl-10 properties-span">
                Default notification period
              </span>
            </label>
            <div className="expiry-period-style pl-10 pt-3">
              <input
                variant="outlined"
                size="small"
                className="expiry-field form-control"
                value={expiryperiodList.NotificationValue}
                onChange={(e) => handleNotificationInputChange(e)}
              />
              <label className="pl-10 properties-label">Days</label>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ExpiryPeriod;
